module.exports = __webpack_public_path__ + "img/illu_delete_newMedia.0b27deb3.png";